import React, { useCallback, useEffect, useState } from 'react';
import { setScoreboardHasError } from 'features/sport/sportSlice';
import { ScoreBoardProvider } from 'features/sport/types';
import { useAppDispatch } from 'lib/centralStore';
import { getNonce } from 'lib/policy';
import { isClientSide } from 'utility/constant';
import styles from './BetGeniusScoreboard.module.scss';

export type BetGeniusScoreboardProps = {
  disciplina: number;
  providerID: string;
  locale?: string;
  isOpen: boolean;
};

export const BetGeniusScoreboard = ({ disciplina, providerID, isOpen }: BetGeniusScoreboardProps) => {
  let disciplinaPath!: string;
  const [iframe, setIframe] = useState<HTMLIFrameElement>();
  const dispatch = useAppDispatch();

  // TODO: HANDLE LOCALE (?)
  // TODO: HANDLE CLOSED AND OPENED STATUS

  switch (disciplina) {
    case 1: // CALCIO
      disciplinaPath = `page/snai/footballscorecentre?culture=it-IT&`;
      break;
    case 2: // BASKET
      disciplinaPath = `page/snai/basketballscorecentre?culture=it-IT&`;
      break;
    case 3: // TENNIS
      disciplinaPath = `tennisscorecentre/snaitennisscorecentre/html?`;
      break;
    default: {
      setTimeout(() => {
        dispatch(setScoreboardHasError({ hasError: true, provider: ScoreBoardProvider.Snai }));
      }, 100);
    }
  }

  const onMessageHandler = useCallback(
    (e) => {
      if (iframe instanceof HTMLIFrameElement && e.isTrusted && !!e.data && typeof e.data === 'string') {
        try {
          iframe.style.height = `${JSON.parse(e.data).height}px`;
        } catch (e) {}
      }
    },
    [iframe]
  );

  useEffect(() => {
    if (isClientSide) {
      window.addEventListener('message', onMessageHandler);
    }

    return () => {
      if (isClientSide) {
        window.removeEventListener('message', onMessageHandler);
      }
    };
  }, [onMessageHandler]);

  if (disciplinaPath) {
    return (
      <div className={`${styles.content} ${isOpen ? styles.visible : styles.hidden}`}>
        <iframe
          scrolling="no"
          id="betgenius-iframe"
          src={`${process.env.NEXT_PUBLIC_BETGENIUS_URL}/${disciplinaPath}eventId=${providerID}`}
          width="100%"
          onLoad={(event) => {
            setIframe(event.currentTarget);
          }}
          nonce={getNonce()}
        />
      </div>
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <React.Fragment />;
};